/**
 * @generated SignedSource<<40626125610af6fcf75b88e94d136f63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type QueriesSchemaVersionsWithReferencesAndDocumentsQuery$variables = {
  at?: string | null;
  orderBy?: ReadonlyArray<string> | null;
  schemaIds?: ReadonlyArray<number> | null;
};
export type QueriesSchemaVersionsWithReferencesAndDocumentsQuery$data = {
  readonly schemaVersions: ReadonlyArray<{
    readonly schema: {
      readonly _id: number;
      readonly documents: ReadonlyArray<{
        readonly _id: number;
      }>;
      readonly referencedByDocumentVersions: ReadonlyArray<{
        readonly document: {
          readonly _id: number;
        };
      }>;
      readonly referencedBySchemaVersions: ReadonlyArray<{
        readonly schema: {
          readonly _id: number;
        };
      }>;
      readonly versionAt: {
        readonly _id: number;
        readonly referencingSchemas: ReadonlyArray<{
          readonly _id: number;
        }>;
      } | null;
    };
  } | null>;
};
export type QueriesSchemaVersionsWithReferencesAndDocumentsQuery = {
  response: QueriesSchemaVersionsWithReferencesAndDocumentsQuery$data;
  variables: QueriesSchemaVersionsWithReferencesAndDocumentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "at"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schemaIds"
},
v3 = {
  "kind": "Variable",
  "name": "at",
  "variableName": "at"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v5 = [
  (v3/*: any*/)
],
v6 = [
  (v4/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": [
      (v3/*: any*/),
      {
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "orderBy"
      },
      {
        "kind": "Variable",
        "name": "schemaIds",
        "variableName": "schemaIds"
      }
    ],
    "concreteType": "SchemaVersion",
    "kind": "LinkedField",
    "name": "schemaVersions",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Schema",
        "kind": "LinkedField",
        "name": "schema",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "Document",
            "kind": "LinkedField",
            "name": "documents",
            "plural": true,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "SchemaVersion",
            "kind": "LinkedField",
            "name": "versionAt",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "Schema",
                "kind": "LinkedField",
                "name": "referencingSchemas",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "DocumentVersion",
            "kind": "LinkedField",
            "name": "referencedByDocumentVersions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Document",
                "kind": "LinkedField",
                "name": "document",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "SchemaVersion",
            "kind": "LinkedField",
            "name": "referencedBySchemaVersions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Schema",
                "kind": "LinkedField",
                "name": "schema",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QueriesSchemaVersionsWithReferencesAndDocumentsQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "QueriesSchemaVersionsWithReferencesAndDocumentsQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "857ae9442e4bfdf0c9d9efef9bb46a4e",
    "id": null,
    "metadata": {},
    "name": "QueriesSchemaVersionsWithReferencesAndDocumentsQuery",
    "operationKind": "query",
    "text": "query QueriesSchemaVersionsWithReferencesAndDocumentsQuery(\n  $schemaIds: [Int!]\n  $at: DateTime\n  $orderBy: [String!]\n) {\n  schemaVersions(schemaIds: $schemaIds, at: $at, orderBy: $orderBy) {\n    schema {\n      _id\n      documents(at: $at) {\n        _id\n      }\n      versionAt(at: $at) {\n        _id\n        referencingSchemas(at: $at) {\n          _id\n        }\n      }\n      referencedByDocumentVersions(at: $at) {\n        document {\n          _id\n        }\n      }\n      referencedBySchemaVersions(at: $at) {\n        schema {\n          _id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da81fddc8371c4c4e0f19f1f1f2ce098";

export default node;
